import B0_1 from './audio/B0_1.mp3'
import B0_2 from './audio/B0_2.mp3'
import B0_3 from './audio/B0_3.mp3'
import B0_4 from './audio/B0_4.mp3'
import B0_5 from './audio/B0_5.mp3'
import B0_6 from './audio/B0_6.mp3'
import A1_1 from './audio/A1_1.mp3'
import A1_2 from './audio/A1_2.mp3'
import A1_3 from './audio/A1_3.mp3'
import B1_11 from './audio/B1_11.mp3'
import B1_12 from './audio/B1_12.mp3'
import B1_21 from './audio/B1_21.mp3'
import B1_22 from './audio/B1_22.mp3'
import B1_31 from './audio/B1_31.mp3'
import B1_32 from './audio/B1_32.mp3'
import A2_11 from './audio/A2_11.mp3'
import A2_12 from './audio/A2_12.mp3'
import A2_21 from './audio/A2_21.mp3'
import A2_22 from './audio/A2_22.mp3'
import A2_31 from './audio/A2_31.mp3'
import A2_32 from './audio/A2_32.mp3'
import B2_11 from './audio/B2_11.mp3'
import B2_12 from './audio/B2_12.mp3'
import B2_21 from './audio/B2_21.mp3'
import B2_22 from './audio/B2_22.mp3'
import B2_31 from './audio/B2_31.mp3'
import B2_32 from './audio/B2_32.mp3'
import A3_11 from './audio/A3_11.mp3'
import A3_12 from './audio/A3_12.mp3'
import A3_21 from './audio/A3_21.mp3'
import A3_22 from './audio/A3_22.mp3'
import A3_23 from './audio/A3_23.mp3'
import A3_24 from './audio/A3_24.mp3'
import A3_25 from './audio/A3_25.mp3'
import A3_31 from './audio/A3_31.mp3'
import A3_32 from './audio/A3_32.mp3'
import B3_11 from './audio/B3_11.mp3'
import B3_12 from './audio/B3_12.mp3'
import B3_21 from './audio/B3_21.mp3'
import B3_22 from './audio/B3_22.mp3'
import B3_31 from './audio/B3_31.mp3'
import B3_32 from './audio/B3_32.mp3'
import A4_11 from './audio/A4_11.mp3'
import A4_12 from './audio/A4_12.mp3'
import A4_21 from './audio/A4_21.mp3'
import A4_22 from './audio/A4_22.mp3'
import A4_31 from './audio/A4_31.mp3'
import A4_32 from './audio/A4_32.mp3'
import B4_11 from './audio/B4_11.mp3'
import B4_12 from './audio/B4_12.mp3'
import B4_13 from './audio/B4_13.mp3'
import B4_14 from './audio/B4_14.mp3'
import B4_21 from './audio/B4_21.mp3'
import B4_22 from './audio/B4_22.mp3'
import B4_23 from './audio/B4_23.mp3'
import B4_24 from './audio/B4_24.mp3'
import B4_31 from './audio/B4_31.mp3'
import B4_32 from './audio/B4_32.mp3'
import B4_33 from './audio/B4_33.mp3'
import B4_34 from './audio/B4_34.mp3'
import A_lopetus1 from './audio/A_lopetus1.mp3'
import A_lopetus2 from './audio/A_lopetus2.mp3'
import A_lopetus3 from './audio/A_lopetus3.mp3'
import B_lopetus1 from './audio/B_lopetus1.mp3'
import B_lopetus2 from './audio/B_lopetus2.mp3'
import B_lopetus3 from './audio/B_lopetus3.mp3'
import A5_11 from './audio/A5_11.mp3'
import A5_12 from './audio/A5_12.mp3'
import A5_13 from './audio/A5_13.mp3'
import A5_14 from './audio/A5_14.mp3'
import A5_21 from './audio/A5_21.mp3'
import A5_22 from './audio/A5_22.mp3'
import A5_23 from './audio/A5_23.mp3'
import A5_24 from './audio/A5_24.mp3'
import A5_31 from './audio/A5_31.mp3'
import A5_32 from './audio/A5_32.mp3'
import A5_33 from './audio/A5_33.mp3'
import A5_34 from './audio/A5_34.mp3'
import B_lopetus4 from './audio/B_lopetus4.mp3'
import B_lopetus5 from './audio/B_lopetus5.mp3'
import B_lopetus6 from './audio/B_lopetus6.mp3'
import B_lopetus7 from './audio/B_lopetus7.mp3'
import B_lopetus8 from './audio/B_lopetus8.mp3'
import B_lopetus9 from './audio/B_lopetus9.mp3'
import A_lopetus4 from './audio/A_lopetus4.mp3'
import A_lopetus5 from './audio/A_lopetus5.mp3'
import A_lopetus6 from './audio/A_lopetus6.mp3'
import A_lopetus7 from './audio/A_lopetus7.mp3'
import A_lopetus8 from './audio/A_lopetus8.mp3'
import A_lopetus9 from './audio/A_lopetus9.mp3'
import hissimusa from './audio/hissimusa.mp3'
import loppumusiikki_tappio from './audio/loppumusiikki_tappio.mp3'
import loppumusiikki_voitto from './audio/loppumusiikki_voitto.mp3'
import phonedial from './audio/phonedial.mp3'
import phonerings from './audio/phonerings.mp3'
import puhelinhalyttaa from './audio/puhelinhalyttaa.mp3'
import gong from './audio/gong.mp3'

import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

const audios = {
    B0_1: B0_1,
    B0_2: B0_2,
    B0_3: B0_3,
    B0_4: B0_4,
    B0_5: B0_5,
    B0_6: B0_6,
    A1_1: A1_1,
    A1_2: A1_2,
    A1_3: A1_3,
    B1_11: B1_11,
    B1_12: B1_12,
    B1_21: B1_21,
    B1_22: B1_22,
    B1_31: B1_31,
    B1_32: B1_32,
    A2_11: A2_11,
    A2_12: A2_12,
    A2_21: A2_21,
    A2_22: A2_22,
    A2_31: A2_31,
    A2_32: A2_32,
    B2_11: B2_11,
    B2_12: B2_12,
    B2_21: B2_21,
    B2_22: B2_22,
    B2_31: B2_31,
    B2_32: B2_32,
    A3_11: A3_11,
    A3_12: A3_12,
    A3_21: A3_21,
    A3_22: A3_22,
    A3_23: A3_23,
    A3_24: A3_24,
    A3_25: A3_25,
    A3_31: A3_31,
    A3_32: A3_32,
    B3_11: B3_11,
    B3_12: B3_12,
    B3_21: B3_21,
    B3_22: B3_22,
    B3_31: B3_31,
    B3_32: B3_32,
    A4_11: A4_11,
    A4_12: A4_12,
    A4_21: A4_21,
    A4_22: A4_22,
    A4_31: A4_31,
    A4_32: A4_32,
    B4_11: B4_11,
    B4_12: B4_12,
    B4_13: B4_13,
    B4_14: B4_14,
    B4_21: B4_21,
    B4_22: B4_22,
    B4_23: B4_23,
    B4_24: B4_24,
    B4_31: B4_31,
    B4_32: B4_32,
    B4_33: B4_33,
    B4_34: B4_34,
    A_lopetus1: A_lopetus1,
    A_lopetus2: A_lopetus2,
    A_lopetus3: A_lopetus3,
    B_lopetus1: B_lopetus1,
    B_lopetus2: B_lopetus2,
    B_lopetus3: B_lopetus3,
    A5_11: A5_11,
    A5_12: A5_12,
    A5_13: A5_13,
    A5_14: A5_14,
    A5_21: A5_21,
    A5_22: A5_22,
    A5_23: A5_23,
    A5_24: A5_24,
    A5_31: A5_31,
    A5_32: A5_32,
    A5_33: A5_33,
    A5_34: A5_34,
    B_lopetus4: B_lopetus4,
    B_lopetus5: B_lopetus5,
    B_lopetus6: B_lopetus6,
    B_lopetus7: B_lopetus7,
    B_lopetus8: B_lopetus8,
    B_lopetus9: B_lopetus9,
    A_lopetus4: A_lopetus4,
    A_lopetus5: A_lopetus5,
    A_lopetus6: A_lopetus6,
    A_lopetus7: A_lopetus7,
    A_lopetus8: A_lopetus8,
    A_lopetus9: A_lopetus9,
    hissimusa: hissimusa,
    loppumusiikki_tappio: loppumusiikki_tappio,
    loppumusiikki_voitto: loppumusiikki_voitto,
    phonedial: phonedial,
    phonerings: phonerings,
    puhelinhalyttaa: puhelinhalyttaa,
    gong: gong
}

export const useAudios = () => {
    const volumeOn = useSelector(state => state.volume)

    useEffect(() => {
    }, [volumeOn])


    const getAudio = (code) => {
        return audios[code]
    }

    const setAndPlay = (code, loop) => {
        return new Promise(async (resolve, reject) => {
                const audio = new Audio(getAudio(code))
                audio.preload = 'auto'
                audio.autoplay = true
                audio.onerror = reject
                audio.onended = resolve
                audio.muted = !volumeOn
    
                if (loop) {
                    audio.loop = true
                } 
            
        })
    }

    return {
        setAndPlay,
    }
}